import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export const UserLoader = () => (
  <Box sx={{ width: 174, display: 'flex', gap: '6px', alignItems: 'center' }}>
    <Skeleton sx={{ backgroundColor: '#f0f1f5' }} width={36} height={36} animation="wave" variant="circular" />
    <Skeleton sx={{ backgroundColor: '#f0f1f5' }} width={116} height={28} animation="wave" variant="rounded" />
  </Box>
);
